import { render, staticRenderFns } from "./SignUpStart.vue?vue&type=template&id=862c8db2&scoped=true"
import script from "./SignUpStart.vue?vue&type=script&lang=js"
export * from "./SignUpStart.vue?vue&type=script&lang=js"
import style0 from "./SignUpStart.vue?vue&type=style&index=0&id=862c8db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862c8db2",
  null
  
)

export default component.exports